import React from 'react'
import AboutHero from '../about-hero'
import AboutWhatPrivacy from '../about-what-privacy'
// import { useGetPrivacyQuery } from 'src/store/Reducer/settings'

export default function PrivacyPolicyView() {
  // const { data } = useGetPrivacyQuery();
  const data = {}
  return (
    <>
      <AboutHero data={{ title: "Our", list: ['Privacy Policy'] }} />
      <AboutWhatPrivacy data={{ title: "", content: data?.body?.privacy, image: '/assets/images/about/Privacy_Policy.png' }} />
    </>
  )
}
